export const isIOS = (/iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel') && !('MSStream' in window);
export const isTouchDevice = !matchMedia('(hover:hover)').matches;